<template>
  <div>
    <v-data-table :headers="headers" :items="customers" :items-per-page="15" :search="search" class="elevation-1">
      <template v-slot:item.description="{ item }">
        <v-tooltip left v-if="item.description">
          <template v-slot:activator="{ on, attrs }">
            <v-icon v-bind="attrs" v-on="on" color="green">mdi-check-bold</v-icon>
          </template>
          <span>{{ item.description }}</span>
        </v-tooltip>
      </template>
      <template v-slot:item.action="{ item }">
        <v-icon @click="onEdit(item)">mdi-account-edit</v-icon>
        &nbsp;
        <v-icon @click="deleteItem(item)" color="red">mdi-account-remove</v-icon>
      </template>
      <template v-slot:no-data>
        {{ $t("common.list.noResults") }}
      </template>
    </v-data-table>

  </div>
</template>

<script>
import axios from "axios";
import { formatMixin, listMixin } from "@/helpers/mixins";

export default {
  mixins: [formatMixin, listMixin],

  components: {
  },

  data() {
    return {
      headers: [
        { text: this.$i18n.t("customers.list.name"), align: "left", value: "name" },
        { text: this.$i18n.t("customers.list.playerUrl"), align: "left", value: "playerUrl" },
        { text: this.$i18n.t("customers.list.description"), align: "center", value: "description" },
        { text: this.$i18n.t("common.list.actions"), value: "action", sortable: false },
      ],
      search: ""
    };
  },

  props: {
    customers: {
      type: Array,
      default: () => []
    },
    onEdit: {
      type: Function
    },
    onChange: {
      type: Function
    }

  },
  
  computed: {
  },

  created() {
  },

  methods: {
    setState: function(id, action) {
      axios
        .get(`/api/customers/${id}/${action}`)
        .then(() => {
          this.onChange();
        })
        .catch((e) => {
          console.log(e);
        });
    },

    deleteItem: function(item) {
      if (confirm(this.$i18n.t("customers.delete.confirmMessage"))) {
        axios
          .delete(`/api/customers/${item.id}`)
          .then(() => {
            this.onChange();
          })
          .catch((e) => {
            console.log(e);
          });
      }
    },

    setPwd: function(item) {
      this.$refs.pwdForm.init(item.id);
      this.$refs.pwdPanel.show();
    },

    closePwdPanel: function() {
      this.$refs.pwdPanel.hide();
      this.$store.dispatch("showSnackMessage", { message: this.$i18n.t("common.list.actions") });
    }
    
  },
};
</script>
